import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { UtilsService } from 'src/app/utils/utils.service';
import { FOGALERT_VIEWTYPE } from '../fog-map/fog-map-constants';
import { ToastrService } from 'ngx-toastr';
import { DatepickerComponent } from 'src/app/utils/datepicker/datepicker.component';
import { UtilsSharedModule } from 'src/app/main/shared/utils/utils/utils.module';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';

@Component({
  selector: 'app-fog-sidebar',
  templateUrl: './fog-sidebar.component.html',
  styleUrls: ['./fog-sidebar.component.scss']
})
export class FogSidebarComponent implements OnInit {


  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();

  selected: any = 'fog';
  // selectedSource: any;
  selectedSource: any = 'ECMWF';
  sourceOptions: any = {
    'ECMWF': 'ecmwf_1hr',
    'Fog Forecast Vassar': 'ecmwf_1hr_fog_visibility'
  };
  modalRef: any;

  sourceMapping = {
    ecmwf_1hr: 'ecmwf_1hr_hourly',
    ecmwf_1hr_fog_visibility: 'ecmwf_1hr_fog_visibility_hourly'
  };
  queryParams: any = {};
  isDistrictChecked: boolean = false
  isAviationChecked: boolean = false
  isRailwayChecked: boolean = false
  isHighwayChecked: boolean = false
  disableAviation: boolean = true
  disableRailway: boolean = true
  disableHighway: boolean = true
  selectedFogView: any;
  @ViewChild(DatepickerComponent, {
    static: false
  }) datepicker: DatepickerComponent;
  minDate: any;
  maxDate: any;
  sDate: object = { required: true };
  eDate: object = { required: true };
  format: object = { required: true };
  validation: boolean[] = new Array(5).fill(true);
  selectedFormat: any = 'DAILY'
  formatOptions: any = { 'Daily': 'DAILY', 'Hourly': 'HOURLY' }

  subscriptions: any = [];


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private utils: UtilsService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private utilsShared: UtilsSharedModule,
    private gisMapComp: GisDimsMapComponent

  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
      this.selectedSource = this.queryParams.source
      this.selectedFogView = this.queryParams.fogView
      this.selectedFormat = this.queryParams['format']
      //this.setDatesFormat()
      this.emitSelectedParams();
      if (this.selectedFogView == 'observed') {
        this.resetSectorData()
      } else {
        this.setSectorLayers()
      }
    });
  }

  setSectorLayers() {
    if (this.isAviationChecked) {
      this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Airport Boundary', this.isAviationChecked)
    }
    if (this.isRailwayChecked) {
      this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Railway Boundary', this.isRailwayChecked)

    }
    if (this.isHighwayChecked) {
      this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Highway Boundary', this.isHighwayChecked)

    }
  }

  setDatesFormat() {
    this.format['value'] = 'yyyyMMdd'
    this.setStartDate(this.utilsShared.getDateObjectFromModelDate('20260110'))
    this.setEndDate(this.utilsShared.getDateObjectFromModelDate('20260119'))
  }

  setStartDate(date: Date): void {
    this.sDate['value'] = date;  //this.utils.getDateObjectFromModelDate(this.ytd['value']);
    this.minDate = date
  }

  setEndDate(date: Date): void {
    this.eDate['value'] = date; //this.utils.getDateObjectFromModelDate(this.ytd['value']);
    this.maxDate = date
  }

  ngOnChanges(change: SimpleChanges) {
    // let timeStamp = this.labelStrings[this.blockNum].groupName;
    // this.gisUtils.setTimeStamp(timeStamp)
  }

  onParamsChange() {
    const options = {
      ...this.queryParams,
      source: this.selectedSource,
      format: this.selectedFormat
    };
    this.router.navigate(
      ['/fogwatch/fog/akbm'],
      { queryParams: options, queryParamsHandling: 'merge' }
    );
  }

  resetInfoboxAlertView() {
    if (this.isAviationChecked) {
      this.setFogAlertViewInInfobox(this.isAviationChecked, 'Airport Boundary')
    }
    if (this.isRailwayChecked) {
      this.setFogAlertViewInInfobox(this.isRailwayChecked, 'Railway Boundary')
    }
    if (this.isHighwayChecked) {
      this.setFogAlertViewInInfobox(this.isHighwayChecked, 'Highway Boundary')

    }
  }

  emitSelectedParams() {
    const params: any = {
      component: 'FOG',
      // source: this.sourceMapping[this.selectedSource],
      source: 'ECMWF',
      actionType: 'filter',
      view: 'ADMIN',
      pType: 'COUNTRY',
      cType: 'STATE',
      parentLoc: 'COUNTRY',
      dashboardView: 'INDIA'
    };

    this.utils.selectedParams.next(params);
  }
  infoclick(value) {
    this.modalRef = this.modalService.open(InfomodalComponent, { backdrop: 'static', keyboard: true, windowClass: 'backgroundTransparent  infocomponent' })
    this.modalRef.componentInstance.selected = value;
  }

  toggleDistrictLayer(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isDistrictChecked = checkbox.checked;
    this.utils.fogDistrictLayerToggle.next(this.isDistrictChecked)

    this.isAviationChecked = false
    this.isRailwayChecked = false
    this.isHighwayChecked = false
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, '', this.isDistrictChecked)
    this.utils.setViewForFogAlert.next({})
  }

  toggleAviationLayer(event, type) {
    const checkbox = event.target as HTMLInputElement;
    this.isAviationChecked = checkbox.checked;
    this.utils.fogAvaitionLayerToggle.next(this.isAviationChecked)

    this.isDistrictChecked = false
    this.isRailwayChecked = false
    this.isHighwayChecked = false
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, type, this.isAviationChecked)
    this.setFogAlertViewInInfobox(this.isAviationChecked, type)
  }


  toggleRailwayLayer(event, type) {
    const checkbox = event.target as HTMLInputElement;
    this.isRailwayChecked = checkbox.checked;
    this.utils.fogRailwayLayerToggle.next(this.isRailwayChecked)

    this.isAviationChecked = false
    this.isDistrictChecked = false
    this.isHighwayChecked = false
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, type, this.isRailwayChecked)
    this.setFogAlertViewInInfobox(this.isRailwayChecked, type)
  }

  toggleHighwayLayer(event, type) {
    const checkbox = event.target as HTMLInputElement;
    this.isHighwayChecked = checkbox.checked;
    this.utils.fogHighwayLayerToggle.next(this.isHighwayChecked)

    this.isAviationChecked = false
    this.isRailwayChecked = false
    this.isDistrictChecked = false
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, type, this.isHighwayChecked)
    this.setFogAlertViewInInfobox(this.isHighwayChecked, type)
  }

  setFogAlertViewInInfobox(setView, type) {
    let infoObj: any = {}
    if (setView) {
      infoObj = {
        view: FOGALERT_VIEWTYPE[type],
        showAlert: false
      }
    }
    this.utils.setViewForFogAlert.next(infoObj)
  }

  ngOnDestroy() {
    this.utils.fogDistrictLayerToggle.next(null)
    this.resetSectorData()
  }

  resetSectorData() {
    this.isAviationChecked = false
    this.isRailwayChecked = false
    this.isHighwayChecked = false
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Airport Boundary', this.isAviationChecked)
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Railway Boundary', this.isRailwayChecked)
    this.gisMapComp.injectedService['handleSectorWiseLayers'](this.gisMapComp, this.queryParams, 'Highway Boundary', this.isHighwayChecked)
    this.utils.setViewForFogAlert.next({})
  }

  changeFogView(view) {
    const options = {
      ...this.queryParams,
      fogView: view,
      format: view == 'observed' ? 'HOURLY' : 'DAILY',
      source: 'ecmwf_1hr'
    };
    this.router.navigate(
      ['/fogwatch/fog/akbm'],
      { queryParams: options, queryParamsHandling: 'merge' }
    );
  }
}
